import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { Offline, Detector } from 'react-detect-offline'
import { renderField } from '../../components/utils/input'
import Config from '../../config'
import { SecureStorage } from '../../utils'
import validate from './validate'
import './styles.scss'
import CommonModal from '../Modals/common'

class SignUp extends Component {
  constructor() {
    super()
    this.state = {
      accountExists: false, // If account is already exists
      welcomeSignup: false // If true then will open the modal welcome
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.closeWelcomeSignup = this.closeWelcomeSignup.bind(this)
  }

  componentWillMount() {
    // Once user successful signed up need to send over register cozy page
    if (localStorage.getItem('Authorization')) {
      this.props.history.push('/register-cozy')
    }
  }

  componentWillReceiveProps(np) {
    const { signinSuccess, history } = np
    if (signinSuccess) {
      // shows modal on sign up error (Account already exists)
      if (signinSuccess.errors) {
        this.setState({ accountExists: true }, () => {
         this.props.signOut()
        })
      }
      // redirects to register cozy page on sucessfully sign up
      if (!signinSuccess.errors) {
        // Encrypted auth token due to security reason and de-crypted while calling the api
        const token = SecureStorage.encrypt(signinSuccess.data.createAccount)
        // Set encypted token to local storage
        localStorage.setItem(Config.LocalStorageKeys.Authorization, token)
        localStorage.setItem('temperatureType', 'F') // Local storage to identify Celsius and Fahrenheit setting by user
        history.push('/register-cozy')
      }
    }
  }

  componentDidMount() {
    this.setState({ welcomeSignup: true })
  }

  // Api call to sign up
  onSubmit(data) {
    const { signIn } = this.props
    signIn(data)
  }

  // Modal close handler and will be called from child component
  closeModal(pagePreserve) {
    const { history } = this.props
    this.setState({ accountExists: false })
    if (!pagePreserve) {
      history.push('/login')
    }
  }

  // Modal close handler and will be called from child component
  closeWelcomeSignup() {
    this.setState({ welcomeSignup: false })
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <div>
        <main id="signup-page">
          <Detector
            render={({ online }) => (
              <div className={online ? '' : 'internet-offline'}>
                <Offline>You are offline at the moment!</Offline>
              </div>
            )}
          />
          <div className="wrapper">
            <header className="header display-flex d-blck d-md-none d-md-none">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 align-middle d-flex  align-items-center justify-content-center">
                    <Link className="close" to="/login">
                      <img alt="" src="img/close-icon.png" />
                    </Link>
                  </div>
                </div>
              </div>
            </header>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 login-box-left">
                  <div className="login-box-left-inner">
                    <h1 className="page-title d-blck d-md-none">Create your account!</h1>
                    <img alt="" className="d-none d-md-block" src="img/login_left_img.png" />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12 login-box-right">
                  <div className="login-form">
                    <div className="header-img-box d-none d-md-block">
                      <Link to="/home">
                        <img src="/img/yellow-logo.png" alt="" />
                      </Link>
                      <div className="logo-title">Operated by Radiator Labs</div>
                    </div>
                    <form className="form" onSubmit={handleSubmit(this.onSubmit)}>
                      <h1 className="page-title text-left d-none d-md-block">Create your account!</h1>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Email Address</label>
                        <div className="input-box">
                          <Field name="email" component={renderField} type="email" className="form-control email-icon" placeholder="Enter email" />
                          <img className="img-fluid emailimg-icon" src="/img/email-icon.svg" alt="" />
                        </div>
                      </div>
                      <div className="form-group">
                        <label>Password</label>
                        <div className="input-box">
                          <Field
                            name="password"
                            component={renderField}
                            type="password"
                            className="form-control password-icon"
                            placeholder="Password"
                            autoComplete="none"
                          />
                          <img className="img-fluid emailimg-icon password-icon" src="/img/password-icon.svg" alt="" />
                        </div>
                      </div>
                      <div className="form-group">
                        <label>Confirm Password</label>
                        <div className="input-box">
                          <Field
                            name="confirmPassword"
                            component={renderField}
                            type="password"
                            className="form-control password-icon"
                            placeholder="Confirm password"
                            autoComplete="none"
                          />
                          <img className="img-fluid emailimg-icon password-icon" src="/img/password-icon.svg" alt="" />
                        </div>
                      </div>
                      <button type="submit" className="btn btn-primary btn-lg btn-block">
                        Create Account
                      </button>
                      <div className="login-signup-link">
                        <span>
                          Already have an account?{' '}
                          <Link className="link" to="/login">
                            Login
                          </Link>
                        </span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CommonModal
            key="welcomeSignup"
            modalType="welcomeSignup"
            open={this.state.welcomeSignup}
            {...this.props}
            closeModal={this.closeWelcomeSignup}
          />
          <CommonModal key="accountExists" modalType="accountExists" open={this.state.accountExists} {...this.props} closeModal={this.closeModal} />
        </main>
      </div>
    )
  }
}

export default reduxForm({
  form: 'SignUp', // a unique identifier for this form
  destroyOnUnmount: true,
  validate
})(SignUp)



// WEBPACK FOOTER //
// ./src/views/SignUp/component.js